import { Injectable } from '@angular/core';
import { ShipmentSpecialFreightManagerEndpoint } from '../constants';
import { SpecialFreightIdView } from '../../../models';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { API_URL } from '../../../../services/config';
import { getQueryStringFromObject } from '../../../../common/utils';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightItemService {
  constructor(private http: WrapperHttpService) {}

  getNotificationListCount(specialFreightIdView: SpecialFreightIdView): Observable<number> {
    return this.http
      .withLoading()
      .get(
        `${API_URL}${ShipmentSpecialFreightManagerEndpoint.Base}${
          ShipmentSpecialFreightManagerEndpoint.SpecialFreights
        }${ShipmentSpecialFreightManagerEndpoint.Notifications}${
          ShipmentSpecialFreightManagerEndpoint.Count
        }?${getQueryStringFromObject<SpecialFreightIdView>(specialFreightIdView)}`,
      );
  }
}
